import { Suspense } from 'react';
import { useAppContext } from '../hooks';
import { ErrorBoundary } from './ErrorBoundary';

export interface PlaceholderProps {
    data?: Record<string, unknown>;
    contentPlaceHolderId: string;
    parentWidgetInstanceId: string;
    renderNull?: boolean;
}

const NotSupportedComponent = (props: { type: string }) => (
    <div>{`Component ${props.type} is not supported`}</div>
);

export const ViewerPlaceholder = ({
    data,
    contentPlaceHolderId,
    parentWidgetInstanceId,
    renderNull,
}: PlaceholderProps) => {
    const { document, widgetFactory } = useAppContext();
    const widgetInstances = document?.widgetInstances;
    const parentWidgetInstance = (widgetInstances || {})[parentWidgetInstanceId];

    const childWidgetInstanceIds = parentWidgetInstance
        ? parentWidgetInstance.contentPlaceHolders[contentPlaceHolderId]
        : [];

    return (
        <>
            {widgetInstances &&
                childWidgetInstanceIds &&
                childWidgetInstanceIds.map((childWidgetInstanceId: string, i: number) => {
                    const widgetInstance = widgetInstances[childWidgetInstanceId];

                    if (!widgetInstance) {
                        return null;
                    }

                    const widget = widgetFactory.getWidget(widgetInstance.widgetId);

                    if (!widget) {
                        return (
                            <div key={i} className="placeholder">
                                <NotSupportedComponent type={widgetInstance?.widgetId || ''} />
                            </div>
                        );
                    }

                    if (renderNull) {
                        return '__';
                    }

                    const Comp: any = widget.templateView;
                    return (
                        <ErrorBoundary key={i}>
                            <Suspense fallback={null}>
                                <Comp widgetInstanceId={childWidgetInstanceId} data={data} />
                            </Suspense>
                        </ErrorBoundary>
                    );
                })}
        </>
    );
};
